module.exports = __webpack_public_path__ + "img/x-white.19fa5c72.svg";